import React from "react";
import {
  ALL_AGENCY_LIST,
  FORGET_PASSWORD_OTP_URL,
} from "../constants/ApiPaths";
import {
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from "reactstrap";
import { SIGNIN_ROUTE } from "../constants/RoutePaths";
import { Link } from "react-router-dom";

function SendOtp(props) {
  const {
    loading,
    setFlag,
    setLoading,
    enqueueSnackbar,
    useFormik,
    Yup,
    API,
    authHeader,
    CustomButtonLoader,
    CustomAlertMessage,
    setEmail,
  } = props;

  const initialValues = {
    email: "",
  };

  // validation schema
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email Required"),
  });

  //formik
  const {
    handleSubmit,
    handleChange,
    values,
    // handleBlur,
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: (values) => getOTP(values),
  });
  const getAllAgency = async () => {
    const config = {
      method: "POST",
      url: ALL_AGENCY_LIST,
      // headers: authHeader(),
      data: {
        count: 10,
        offset: 0,
        agencyName: "",
        email: values.email,
      },
    };
    const response = await API(config);
   console.log(response)
  };
  const handleBlur = async () => {
    getAllAgency();
  };

  //for getting otp
  const getOTP = async (values) => {
    const { email } = values;
    //     let f=list.filter((r)=>r.agencyId==agencyId)
    //     let agencyUrl=''
    //     if(f){
    // agencyUrl=f[0].agencyUrl
    //     }
    //     localStorage.setItem('FORGOT_AGENCY_ID',agencyId)
    //     localStorage.setItem('FORGOT_AGENCY_URL',agencyUrl)
    setLoading(true);
    const config = {
      method: "POST",
      url: FORGET_PASSWORD_OTP_URL,
      data: values,
      headers: authHeader(),
      params: { email: email },
    };
    try {
      const response = await API(config);
      const { status, message } = response.data;

      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        setEmail(values.email);
        setFlag(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h4>Find Your Account</h4>
      <p className="mb-4">Enter your email to get an OTP</p>
      <Form form="true" onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="exampleEmail">Email</Label>
          <Input
            type="email"
            onBlur={handleBlur}
            name="email"
            value={values.email}
            invalid={touched.email && errors.email ? true : false}
            onChange={handleChange}
            id="exampleEmail"
            placeholder="Enter your email"
          />
          <FormFeedback>
            {touched.email && errors.email ? errors.email : ""}
          </FormFeedback>
        </FormGroup>

        {/* Button */}
        <Button color="primary" block>
          {loading && <CustomButtonLoader />}
          Send OTP
        </Button>
        <Link to={SIGNIN_ROUTE}>Sign In?</Link>
      </Form>
    </div>
  );
}

export default SendOtp;
